const paragraph = {
    "baseValue": 10,
    "steps": [{
        value: 6,
        lineHeight: 10,
        name: 1
    }, {
        value: 7,
        lineHeight: 13,
        name: 2
    }, {
        value: 8,
        lineHeight: 12,
        name: 3
    }, {
        value: 9,
        lineHeight: 13,
        name: 4
    }, {
        value: 10,
        lineHeight: 14,
        name: 5
    }, {
        value: 11,
        lineHeight: 15,
        name: 6
    }, {
        value: 12,
        lineHeight: 16,
        name: 7
    }, {
        value: 13,
        lineHeight: 17,
        name: 8
    }, {
        value: 14,
        lineHeight: 18,
        name: 9
    }]
}

const fontSizes = {
    "header-one": {
        "baseValue": 30,
        "steps": [{
            value: 15,
            lineHeight: 17,
            name: 1
        }, {
            value: 22,
            lineHeight: 24,
            name: 2
        }, {
            value: 23,
            lineHeight: 25,
            name: 3
        }, {
            value: 25,
            lineHeight: 27,
            name: 4
        }, {
            value: 30,
            lineHeight: 32,
            name: 5
        }, {
            value: 35,
            lineHeight: 37,
            name: 6
        }, {
            value: 40,
            lineHeight: 42,
            name: 7
        }, {
            value: 45,
            lineHeight: 47,
            name: 8
        }, {
            value: 50,
            lineHeight: 52,
            name: 9
        }]
    },
    "header-two": {
        "baseValue": 14,
        "steps": [{
            value: 10,
            lineHeight: 12,
            name: 1
        }, {
            value: 11,
            lineHeight: 13,
            name: 2
        }, {
            value: 12,
            lineHeight: 14,
            name: 3
        }, {
            value: 13,
            lineHeight: 15,
            name: 4
        }, {
            value: 14,
            lineHeight: 16,
            name: 5
        }, {
            value: 15,
            lineHeight: 17,
            name: 6
        }, {
            value: 16,
            lineHeight: 18,
            name: 7
        }, {
            value: 17,
            lineHeight: 19,
            name: 8
        }, {
            value: 18,
            name: 9
        }]
    },
    "header-three": {
        "baseValue": 14,
        "steps": [{
            value: 10,
            lineHeight: 12,
            name: 1
        }, {
            value: 11,
            lineHeight: 13,
            name: 2
        }, {
            value: 12,
            lineHeight: 14,
            name: 3
        }, {
            value: 13,
            lineHeight: 15,
            name: 4
        }, {
            value: 14,
            lineHeight: 16,
            name: 5
        }, {
            value: 15,
            lineHeight: 17,
            name: 6
        }, {
            value: 16,
            lineHeight: 18,
            name: 7
        }, {
            value: 17,
            lineHeight: 19,
            name: 8
        }, {
            value: 18,
            name: 9
        }]
    },
    "unstyled": paragraph,
    "blockquote": {
            "baseValue": 14,
            "steps": [{
                value: 10,
                lineHeight: 12,
                name: 1
            }, {
                value: 11,
                lineHeight: 13,
                name: 2
            }, {
                value: 12,
                lineHeight: 14,
                name: 3
            }, {
                value: 13,
                lineHeight: 15,
                name: 4
            }, {
                value: 14,
                lineHeight: 16,
                name: 5
            }, {
                value: 15,
                lineHeight: 17,
                name: 6
            }, {
                value: 16,
                lineHeight: 18,
                name: 7
            }, {
                value: 17,
                lineHeight: 19,
                name: 8
            }, {
                value: 18,
                name: 9
            }]
        },
    "unordered-list-item": paragraph,
    "ordered-list-item": paragraph
};

export default fontSizes


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/custom-methods/fontSizeFakeApi.js